import { render, staticRenderFns } from "./createPrescription.vue?vue&type=template&id=a511fb04&scoped=true"
import script from "./createPrescription.vue?vue&type=script&lang=js"
export * from "./createPrescription.vue?vue&type=script&lang=js"
import style0 from "./createPrescription.vue?vue&type=style&index=0&id=a511fb04&prod&scoped=true&lang=css"
import style1 from "./createPrescription.vue?vue&type=style&index=1&id=a511fb04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a511fb04",
  null
  
)

export default component.exports